import { gql } from 'graphql-request'

export const M_SWITCH_PLAN = gql`
  mutation SwitchSubscriptionPlan($annual: Boolean!, $tier: String) {
    switchSubscriptionPlan(annual: $annual, tier: $tier) {
      ... on SwitchPlanResult {
        success
        planName
        interval
      }
      ... on MutationFailure {
        errors {
          message
        }
      }
    }
  }
`
